import React from 'react';

import {
  Typography,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
  Actions,
  Action,
  Link,
  LinkIcon,
  ContentCopyIcon,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { useCopyLink } from 'scenes/Campaigns/hooks';
import { CampaignDetails } from 'scenes/Campaigns/GGCampaigns/components/CampaignDetails';

const GGCampaigns = ({ campaigns }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const copy = useCopyLink();

  const handleOpenCampaign = (id) => {
    openChildComponent(CampaignDetails, {
      id,
    });
  };

  return (
    <React.Fragment>
      <TableContainer>
        <Table striped={true} rightStickyColumnCount={1}>
          <TableHead>
            <TableRow>
              <TableCell width={90}>ID</TableCell>
              <TableCell width={400}>Name</TableCell>
              <TableCell width={120}>Platform</TableCell>
              <TableCell width={108}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {campaigns.map(({ id, name, platform, link, campaignLinks }, i) => {
              const clickLinkUrl = campaignLinks?.find(
                ({ type }) => type.id === 1
              )?.url;

              return (
                <TableRow key={i}>
                  <TableCell size={'small'}>{id}</TableCell>
                  <TableCell size={'small'}>
                    <Link onClick={() => handleOpenCampaign(id)}>
                      <Typography
                        variant={'body2'}
                        lineClamp={3}
                        sx={{
                          wordBreak: 'break-word',
                        }}
                      >
                        {name}
                      </Typography>
                    </Link>
                  </TableCell>
                  <TableCell size={'small'}>{platform?.name}</TableCell>
                  <TableCell size={'small'}>
                    <Actions>
                      <Action
                        icon={<LinkIcon />}
                        label={'Copy click URL'}
                        onClick={() => copy(clickLinkUrl || link, 'Click URL')}
                      />
                      <Action icon={<ContentCopyIcon />}>
                        {campaignLinks?.map(({ type, url }) =>
                          type.id !== 1 ? (
                            <Action
                              label={`Copy ${type.name.toLowerCase()} URL`}
                              onClick={() => copy(url, `${type.name} URL`)}
                            />
                          ) : null
                        )}
                        <Action
                          label={'Copy ID'}
                          onClick={() => copy(id, 'ID')}
                        />
                        <Action
                          label={'Copy name'}
                          onClick={() => copy(name, 'Name')}
                        />
                      </Action>
                    </Actions>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {childComponent}
    </React.Fragment>
  );
};

export default GGCampaigns;
